import { Inbox } from "lucide-react";
import { cn } from "@/lib/cn";

interface EmptyStateProps {
  title: string;
  description?: string;
  action?: React.ReactNode;
  className?: string;
}

export const EmptyState = ({ title, description, action, className }: EmptyStateProps) => (
  <div
    data-testid="empty-state"
    className={cn(
      "flex flex-col items-center justify-center gap-2 px-6 py-14 text-center",
      className,
    )}
  >
    <div className="mb-1 rounded-md border border-border bg-[hsl(var(--surface-raised))] p-3">
      <Inbox className="h-5 w-5 text-muted-foreground" />
    </div>
    <p className="text-sm font-semibold">{title}</p>
    {description && <p className="max-w-sm text-sm text-muted-foreground">{description}</p>}
    {action}
  </div>
);
